import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import {
  CalendarOptions,
  EventClickArg,
  //defineFullCalendarElement,
  EventInput,
  PluginDef,
} from '@fullcalendar/core';

// NOTE: this import must be below @fullcalendar/web-component
import { Router } from '@angular/router';
import listPlugin from '@fullcalendar/list';
import resourceDayGridPlugin from '@fullcalendar/resource-daygrid';
import { BehaviorSubject } from 'rxjs';
import { IncidentalAbsence, Session, TranslationService } from 'src/app/my-sedgwick';
import { EncryptionService } from 'src/app/my-sedgwick/services/encryption.service';
import { CalendarEvent } from 'src/app/shared/models/CalendarEvent';
import { StatusEvent } from 'src/app/shared/models/StatusEvent';
import { ClaimDataService } from 'src/app/shared/services/claim-data.service';
import { UserActionService } from 'src/app/shared/services/user-action.service';
import {
  ConfigurationService,
  InpageAliasService,
} from '../../../../my-sedgwick';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationPipe } from 'src/app/my-sedgwick/pipes/translation.pipe';
import { Aliases } from 'src/app/my-sedgwick/models/aliases';

// make the <full-calendar> element globally available by calling this function at the top-level
// defineFullCalendarElement();

@Component({
  selector: 'app-calendar',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  // imports: [CommonModule],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="tw-max-w-screen-xl">
      <full-calendar
        #fullCalendar
        [options]="calendarOptions"
        (datesSet)="dateSetCallback($event)"
      ></full-calendar>
    </div>
    <ng-template #dialogEventPopup>
      <div class="tw-flex tw-flex-wrap">
        <app-dialog
          [title]="popupTitle | sentenceCase"
          ariaLabel="{{'Event dialog' | sentenceCase}}"
          [width]="700"
          [showActions]="false"
          [showHeader]="true"
          ariaLabelMessage="{{'Close' | sentenceCase}}"
          [customeHeadingClass]="'calHeading'"
          >
          <div class="tw-w-full app-pb3 app-pt1">
            @if (IsAbsence) {
              <table class="tw-w-full">
                <tr>
                  <td class="eventHeading" colspan="2">
                    <!-- see bug 262407
                    <b *ngIf="!isIncidentalAbsence4Feature">Reason :</b>
                    <b *ngIf="isIncidentalAbsence4Feature">Category :</b> -->
                    <b>{{'Reason' | translation : translationRequest}} :</b>
                    {{
                    (absenceDetail.absenceReason +
                    (showReasonSubtype
                    ? ' - ' + absenceDetail.typeOfCallOff
                    : '') |  translation : translationRequest)
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="eventHeading" colspan="2">
                    <b>{{'Start' | translation : translationRequest}} :</b
                      >{{
                      showTimeStamp
                      ? (absenceDetail.absenceStartDate | format : 'dateTime')
                      : (absenceDetail.absenceStartDate | format : 'date')
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="eventHeading" colspan="2">
                      <b>{{'End'| translation : translationRequest}} :</b
                        >{{
                        showTimeStamp
                        ? (absenceDetail.absenceEndDate | format : 'dateTime')
                        : (absenceDetail.absenceEndDate | format : 'date')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="eventHeading" colspan="2">
                        @if (showTimeStamp) {
                          <b>{{'Return Date'| translation : translationRequest}} :</b>
                        }
                        @if (!showTimeStamp) {
                          <b>{{'Return to Work Date' | translation : translationRequest}} :</b>
                        }
                        {{
                        showTimeStamp
                        ? (absenceDetail.estimatedRTWDate | format : 'dateTime')
                        : (absenceDetail.estimatedRTWDate | format : 'date')
                        }}
                      </td>
                    </tr>
                  </table>
                }
                @if (!IsAbsence && isEventDetails) {
                  <table class="tw-w-full">
                    <tr>
                      @if (ShowClaimNoLink) {
                        <td class="eventHeading" colspan="2">
                          <b>{{'Claim Number'| translation : translationRequest}} : </b>
                          {{ eventData.data.claimDetails.claimNumber }}
                        </td>
                      }
                      @if (!ShowClaimNoLink) {
                        <td class="eventHeading" colspan="2">
                          <b>{{'Claim Number'| translation : translationRequest}} : </b>
                          <span routerLink="" href="" (click)="NavigateClaim()"
                            ><a>{{
                            eventData.data.claimDetails.claimNumber
                          }}</a></span
                          >
                        </td>
                      }
                    </tr>
                    <tr>
                      <td class="eventHeading" colspan="2">
                        <b>{{'Date Of Absence'| translation : translationRequest}} : </b
                          >{{ eventData.data.entry.absenceDate | format : 'date' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="eventHeading" colspan="2">
                          <b>{{'Event Type'| translation : translationRequest}} : </b
                            >{{ eventTypeDisplay | translation : translationRequest }}
                          </td>
                        </tr>
                        <tr>
                          <td class="eventHeading" colspan="2">
                            <b>{{'Absence Status'| translation : translationRequest}} : </b
                              >{{ eventData.data.entry.absenceSubStatus | translation : translationRequest }}
                            </td>
                          </tr>
                          <tr>
                            <td class="eventHeading" colspan="2">
                              <b>{{'Duration of Absence'| translation : translationRequest}} : </b
                                >{{ eventData.data.entry.hoursMissed }} {{'hours' | translation : translationRequest}}
                                {{ eventData.data.entry.minutesMissed }} {{'minutes' | translation : translationRequest}}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td class="tw-flex tw-justify-end">
                                <app-button
                                  right1
                                  emphasis="High"
                                  (click)="closeModalPopUp()"
                                  >{{'Close'| translation : translationRequest}}</app-button
                                  >
                                </td>
                              </tr>
                            </table>
                          }
                @if (!IsAbsence && !isEventDetails) {                  
                  <table class="tw-w-full">
                    <tr>
                      @if (ShowClaimNoLink) {
                        <td class="eventHeading" colspan="2">
                          <b>{{'Claim Number'| translation : translationRequest}} : </b>
                          {{ eventData.data.claimDetails.claimNumber }}
                        </td>
                      }
                      @if (!ShowClaimNoLink) {
                        <td class="eventHeading" colspan="2">
                          <b>{{'Claim Number'| translation : translationRequest}} : </b>
                          <span routerLink="" href="" (click)="NavigateClaim()"
                            ><a>{{
                            eventData.data.claimDetails.claimNumber
                          }}</a></span
                          >
                        </td>
                      }
                    </tr>
                    <tr>
                      <td class="eventHeading" colspan="2">
                        <b>{{'Claim Type'| translation : translationRequest}} : </b>
                        {{
                        eventData.data.claimDetails.lob === 'AD'
                        ? (eventData.data.entry.claimDescription + ' Request' |  translation : translationRequest)
                        : (eventData.data.entry.claimDescription | titlecase |  translation : translationRequest)
                        }}
                      </td>
                    </tr>
                    @if (eventData.data.claimDetails.lob !== 'WC') {
                      <tr>
                        <td class="eventHeading" colspan="2">
                          <b
                            >{{
                            (eventData.data.claimDetails.lob !== 'DS'
                            ? eventData.data.claimDetails.lob === 'AD'
                            ? 'Begin Date'
                            : eventData.data.entry.claimDescription.toLowerCase() ===
                            'reduced work schedule'
                            ? 'Leave Begin'
                            : 'Start Date'
                            : 'Benefits Begin') | translation : translationRequest
                            }}:
                          </b>
                          @if (
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'continuous leave'
                            ) {
                            {{
                            eventData.data.entry.continuesStartDate
                            | format : 'date'
                            }}
                          }
                          @if (
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'intermittent leave'
                            ) {
                            {{
                            eventData.data.entry.absenceBeginDate
                            | format : 'date'
                            }}
                          }
                          @if (
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'reduced work schedule'
                            ) {
                            {{
                            eventData.data.entry.absenceBeginDate
                            | format : 'date'
                            }}
                          }
                          @if (eventData.data.claimDetails.lob !== 'LV') {
                            {{ eventData.data.entry.beginDate |format : 'date'  }}
                          }
                        </td>
                      </tr>
                    }
                    @if (
                      eventData.data.claimDetails.lob !== 'WC' &&
                      !eventData.data.entry.isEndDateEmpty
                      ) {
                      <tr
                        >
                        <td class="eventHeading" colspan="2">
                          <b
                            >{{
                            (eventData.data.claimDetails.lob !== 'DS'
                            ? eventData.data.entry.claimDescription.toLowerCase() ===
                            'reduced work schedule'
                            ? 'Leave End'
                            : 'End Date'
                            : 'Benefits End') | translation : translationRequest
                            }}: </b
                            >@if (
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'continuous leave'
                            ) {
                            {{
                            eventData.data.entry.continuesEndDate
                            | format : 'date'
                            }}
                          }
                          @if (
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'intermittent leave'
                            ) {
                            {{
                            eventData.data.entry.absenceEndDate | format : 'date'
                            }}
                          }
                          @if (
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'reduced work schedule'
                            ) {
                            {{
                            eventData.data.entry.absenceEndDate | format : 'date'
                            }}
                          }
                          @if (
                            (eventData.data.claimDetails.lob === 'DS' ||
                            eventData.data.claimDetails.lob === 'AD') &&
                            !eventData.data.entry.isEndDateEmpty
                            ) {
                            {{ eventData.data.entry.endDate | format : 'date'  }}
                          }
                        </td>
                      </tr>
                    }
                    @if (eventData.data.claimDetails.lob === 'WC') {
                      <tr>
                        <td class="eventHeading" colspan="2">
                          <b>{{'Benefit Status'| translation : translationRequest}} : </b>
                          {{ eventData.data.entry.benefitStatus | translation : translationRequest }}
                        </td>
                      </tr>
                    }
                    <tr>
                      <td class="eventHeading" colspan="2">
                        @if (
                          eventData.data.claimDetails.lob === 'DS' ||
                          eventData.data.claimDetails.lob === 'WC' ||
                          eventData.data.claimDetails.lob === 'AD'
                          ) {
                          <b>{{'Status'| translation : translationRequest}} : </b
                            >{{
                            (eventData.data.claimDetails.lob === 'WC'
                            ? getWCClaimStatus(eventData.data.entry)
                            : eventData.data.entry.subStatus !== ''
                            ? eventData.data.entry.status +
                            ' - ' +
                            eventData.data.entry.subStatus
                            : eventData.data.entry.status) | translation : translationRequest
                            }}
                          }
                          @if (
                            eventData.data.claimDetails.lob === 'LV' &&
                            eventData.data.claimDetails.source !== 'L'
                            ) {
                            <b>{{'Leave Status'| translation : translationRequest}} : </b
                              >{{
                              eventData.data.entry.claimDescription.toLowerCase() !==
                              'reduced work schedule'
                              ? (getStatusOthers(eventData.data.entry) | translation : translationRequest)
                              : (getLeaveStatusReduceWS(eventData) | translation : translationRequest)
                              }}
                            }
                            @if (
                              eventData.data.claimDetails.lob === 'LV' &&
                              eventData.data.claimDetails.source === 'L'
                              ) {
                              <b>{{'Leave Status'| translation : translationRequest}} : </b>{{ eventData.data.status | translation : translationRequest }}
                            }
                          </td>
                        </tr>
                        @if (eventData.data.claimDetails.lob === 'LV') {
                          <tr
                            >
                            <td class="eventHeading" colspan="2">
                              <b>{{'Absence Status'| translation : translationRequest}} : </b
                                >{{ getAbsenceStatusDisplay(eventData) }}
                              </td>
                            </tr>
                          }
                          @if (
                            eventData.data.claimDetails.lob !== 'WC' &&
                            eventData.data.claimDetails.lob !== 'DS' &&
                            eventData.data.claimDetails.source !== 'L' &&
                            eventData.data.entry.claimDescription.toLowerCase() ===
                            'intermittent leave'
                            ) {
                            <tr
                              >
                              <td class="eventHeading" colspan="2">
                                <b>{{'Date Absence Reported'| translation : translationRequest}} : </b
                                  >{{
                                  eventData.data.entry.absenceCallInDateTime
                                  | format : 'date'
                                  }}
                                </td>
                              </tr>
                            }
                            @if (
                              eventData.data.claimDetails.lob !== 'WC' &&
                              eventData.data.claimDetails.lob !== 'DS' &&
                              eventData.data.claimDetails.source !== 'L' &&
                              eventData.data.entry.claimDescription.toLowerCase() ===
                              'intermittent leave'
                              ) {
                              <tr
                                >
                                <td class="eventHeading" colspan="2">
                                  <b>{{'Absence Reason'| translation : translationRequest}} : </b
                                    >{{ (eventData.data.entry.absenceReason ?? 'None') | translation : translationRequest }}
                                  </td>
                                </tr>
                              }
                              @if (eventData.data.entry.examiner) {
                                <tr>
                                  <td class="eventHeading" colspan="2">
                                    <b
                                      >{{
                                      examinerAlias | aliasTransform:'titlecase'
                                      }}
                                      : </b
                                      >{{ removedots(eventData.data.entry.examiner) }}
                                    </td>
                                  </tr>
                                }
                                @if (
                                  eventData.data.claimDetails.lob === 'LV' &&
                                  eventData.data.claimDetails.source !== 'L'
                                  ) {
                                  <tr
                                    >
                                    <td class="eventHeading" colspan="2">
                                      <b>{{'Leave Type'| translation : translationRequest}} : </b
                                        >{{
                                        eventData.data.claimDetails.lob !== 'WC'
                                        ? (eventData.data.entry.leaveType | translation : translationRequest)
                                        : (eventData.data.entry.claimDescription | translation : translationRequest)
                                        }}
                                      </td>
                                    </tr>
                                  }
                                  @if (
                                    eventData.data.claimDetails.source !== 'L' &&
                                    eventData.data.claimDetails.lob === 'LV' &&
                                    eventData.data.entry.claimDescription.toLowerCase() !==
                                    'reduced work schedule'
                                    ) {
                                    <tr
                                      >
                                      <td class="eventHeading" colspan="2">
                                        <b>{{'Date Of Absence'| translation : translationRequest}} : </b
                                          >{{ eventData.data.entry.absenceDate | format : 'date'  }}
                                        </td>
                                      </tr>
                                    }
                                    @if (
                                      eventData.data.claimDetails.lob === 'LV' &&
                                      eventData.data.entry.leaveCausedBy
                                      ) {
                                      <tr
                                        >
                                        <td class="eventHeading" colspan="2">
                                          <b>{{'Leave Caused By'| translation : translationRequest}} : </b
                                            >{{ eventData.data.entry.leaveCausedBy | translation : translationRequest }}
                                          </td>
                                        </tr>
                                      }
                                      @if (
                                        eventData.data.claimDetails.lob === 'LV' &&
                                        eventData.data.entry.exhaustionDate &&
                                        eventData.data.entry.claimDescription.toLowerCase() !==
                                        'reduced work schedule'
                                        ) {
                                        <tr
                                          >
                                          <td class="eventHeading" colspan="2">
                                            <b>{{'Exhaustion Date'| translation : translationRequest}}: </b
                                              >{{
                                              eventData.data.entry.exhaustionDate | format : 'date'
                                              }}
                                            </td>
                                          </tr>
                                        }
                                        @if (
                                          eventData.data.claimDetails.lob === 'LV' &&
                                          eventData.data.entry.actualReturnToWorkDate &&
                                          eventData.data.entry.claimDescription.toLowerCase() !==
                                          'reduced work schedule'
                                          ) {
                                          <tr
                                            >
                                            <td class="eventHeading" colspan="2">
                                              <b>{{'Actual Return To Work Date' | translation : translationRequest}} : </b
                                                >{{
                                                eventData.data.entry.actualReturnToWorkDate
                                                | format : 'date'
                                                }}
                                              </td>
                                            </tr>
                                          }
                                          @if (
                                            eventData.data.claimDetails.lob !== 'DS' &&
                                            eventData.data.entry.relationship &&
                                            eventData.data.entry.claimDescription.toLowerCase() !==
                                            'reduced work schedule'
                                            ) {
                                            <tr
                                              >
                                              <td class="eventHeading" colspan="2">
                                                <b>{{'Relationship'| translation : translationRequest}} : </b
                                                  >{{ eventData.data.entry.relationship | translation : translationRequest }}
                                                </td>
                                              </tr>
                                            }
                                            @if (
                                              eventData.data.claimDetails.lob === 'DS' &&
                                              eventData.data.entry.lastMedicalReceived
                                              ) {
                                              <tr
                                                >
                                                <td class="eventHeading" colspan="2">
                                                  <b>{{'Last Medical Received'| translation : translationRequest}} : </b
                                                    >{{
                                                    eventData.data.entry.lastMedicalReceived
                                                    | format : 'date'
                                                    }}
                                                  </td>
                                                </tr>
                                              }
                                              @if (
                                                eventData.data.claimDetails.lob === 'WC' ||
                                                eventData.data.claimDetails.lob === 'DS'
                                                ) {
                                                <tr
                                                  >
                                                  <td class="eventHeading" colspan="2">
                                                    <b>{{
                                                      (eventData.data.claimDetails.lob === 'WC'
                                                      ? 'Date Of Injury :'
                                                      : 'First Absence :') | translation : translationRequest
                                                      }}</b
                                                      >{{ eventData.data.entry.lossDate | format : 'date' }}
                                                    </td>
                                                  </tr>
                                                }
                                                @if (
                                                  eventData.data.claimDetails.lob === 'WC' ||
                                                  eventData.data.claimDetails.lob === 'DS'
                                                  ) {
                                                  <tr
                                                    >
                                                    <td class="eventHeading" colspan="2">
                                                      <b>{{'Current Work Status'| translation : translationRequest}}: </b
                                                        >{{ eventData.data.entry.workStatus | translation : translationRequest }}
                                                      </td>
                                                    </tr>
                                                  }
                                                  @if (eventData.data.claimDetails.lob === 'AD') {
                                                    <tr>
                                                      <td class="eventHeading" colspan="2">
                                                        <b>{{'Type'| translation : translationRequest}}: </b>{{ eventData.data.entry.accommodationType | translation : translationRequest }}
                                                      </td>
                                                    </tr>
                                                  }
                                                  @if (eventData.data.claimDetails.lob === 'AD') {
                                                    <tr>
                                                      <td class="eventHeading" colspan="2">
                                                        <b>{{'Long Term'| translation : translationRequest}}: </b
                                                          >{{ eventData.data.entry.accommodationLongTerm | translation : translationRequest }}
                                                        </td>
                                                      </tr>
                                                    }
                                                    @if (
                                                      eventData.data.claimDetails.lob === 'WC' &&
                                                      eventData.data.entry.anticipatedReturnToWorkDuty
                                                      ) {
                                                      <tr
                                                        >
                                                        <td class="eventHeading" colspan="2">
                                                          <b>{{'Anticipated Return To Work Duty'| translation : translationRequest}}: </b
                                                            >{{ eventData.data.entry.anticipatedReturnToWorkDuty | translation : translationRequest}}
                                                          </td>
                                                        </tr>
                                                      }
                                                      @if (eventData.data.entry.anticipatedReturnToWorkDate) {
                                                        <tr>
                                                          <td class="eventHeading" colspan="2">
                                                            <b>{{'Anticipated Return To Work Date'| translation : translationRequest}}: </b
                                                              >{{
                                                              eventData.data.entry.anticipatedReturnToWorkDate
                                                              | format : 'date'
                                                              }}
                                                            </td>
                                                          </tr>
                                                        }
                                                        @if (
                                                          eventData.data.claimDetails.source === 'T' &&
                                                          (eventData.data.entry.claimDescription.toLowerCase() ===
                                                          'intermittent leave' ||
                                                          eventData.data.entry.claimDescription.toLowerCase() ===
                                                          'reduced work schedule')
                                                          ) {
                                                          <tr
                                                            >
                                                            <td class="eventHeading" colspan="2">
                                                              <b>{{'Duration of Absence'| translation : translationRequest}} : </b
                                                                >{{ eventData.data.entry.hoursMissed }} {{'hours' | translation : translationRequest}}
                                                                {{ eventData.data.entry.minutesMissed }} {{'minutes' | translation : translationRequest}}
                                                              </td>
                                                            </tr>
                                                          }
                                                          @if (
                                                            eventData.data.claimDetails.source !== 'L' &&
                                                            eventData.data.entry.claimDescription.toLowerCase() ===
                                                            'continuous leave'
                                                            ) {
                                                            <tr
                                                              >
                                                              <td class="eventHeading" colspan="2">
                                                                <b>{{'Duration of Absence'| translation : translationRequest}} : </b
                                                                  >{{ eventData.data.entry.absenceDuration | translation : translationRequest}}
                                                                </td>
                                                              </tr>
                                                            }
                                                            @if (
                                                              eventData.data.claimDetails.source !== 'L' &&
                                                              eventData.data.entry.claimDescription.toLowerCase() ===
                                                              'intermittent leave'
                                                              ) {
                                                              <tr
                                                                >
                                                                <td class="eventHeading" colspan="2">
                                                                  <b>{{'Absence Confirmation Number'| translation : translationRequest}} : </b
                                                                    >{{ eventData.data.entry.absenceConfirmationNumber }}
                                                                  </td>
                                                                </tr>
                                                              }
                                                              <tr>
                                                                <td></td>
                                                                <td class="tw-flex tw-justify-end">
                                                                  <app-button
                                                                    right1
                                                                    emphasis="High"
                                                                    (click)="closeModalPopUp()"
                                                                    >{{'Close'| translation : translationRequest}}</app-button
                                                                    >
                                                                  </td>
                                                                </tr>
                                                              </table>
                                                            }
                                                          </div>
                                                        </app-dialog>
                                                      <!-- </app-panel> -->
                                                    </div>
                                                  </ng-template>
    `,
  styles: [
    `
      ::ng-deep body .fc-toolbar-title {
        font-size: 0.8em;
        text-transform: capitalize!important;
      }

      @media screen and (max-width: 700px) {
        ::ng-deep .fc-toolbar.fc-header-toolbar {
          font-size: 51%;
        }
      }

      .dialog-title {
        color: black;
        font-weight: bold;
        font-size: 18px;
        padding-right: 18px;
      }

      .dialog-x {
        float: right;
        cursor: pointer;
        color: black;
        font-weight: bold;
        font-size: 18px;
        padding-left: 48px;
      }
      ::ng-deep .fc-event {
        white-space: normal !important;
        overflow: hidden;
        text-overflow: ellipsis;
        height: auto !important;
        line-height: 1.2 !important;
        padding: 2px 4px !important;
      }
      ::ng-deep .fc-event-title {
        white-space: normal !important;
        word-wrap: break-word !important;
      }
    `,
  ],
})
export class CalendarComponent implements OnInit, AfterViewInit, OnChanges {
  colorIndex = 0;

  @Input()
  dark = false;

  popupTitle: string;

  @Input()
  IsAbsence: boolean = true;

  @Input()
  translationRequest: TranslationRequest;

  @Input()
  ShowClaimNoLink: boolean = false;
  lightColors = [
    '#ce93d8',
    '#b39ddb',
    '#9fa8da',
    '#90caf9',
    '#81d4fa',
    '#80deea',
    '#80cbc4',
    '#a5d6a7',
    '#c5e1a5',
  ];

  darkColors = [
    '#7b1fa2',
    '#512da8',
    '#303f9f',
    '#1976d2',
    '#0288d1',
    '#0097a7',
    '#00796b',
    '#388e3c',
    '#689f38',
  ];

  calendarOptions: CalendarOptions;
  monthNames: string;
  private removeDotsTimeout: any;
  dateSetCallback(event: any) {
    //console.log('CALENDAR DATE SET!!!!!!!!!!!!!', event);
    this.cdr.detectChanges();

    this.calendarDateUpdated.next(event);

    this.cdr.detectChanges();
    this.render();
    this.removeDotsFromWeekNames();
  }

  @Output()
  calendarDateUpdated: BehaviorSubject<any> = new BehaviorSubject<any>({}); // (v: any) => {};

  absenceDetail: IncidentalAbsence;

  eventData: any;

  @Input()
  toolbarLeft: string = 'prev,next today';

  @Input()
  toolbarRight: string = 'dayGridMonth,dayGridWeek,dayGridDay,listDay';

  @Input()
  events: CalendarEvent[];

  @Input()
  IsListViewShow: boolean = true;

  showTimeStamp: boolean = true;

  showReasonSubtype: boolean = true;
  isIncidentalAbsence4Feature: boolean = false;
  examinerAlias: Aliases = { value: 'Examiner', key: 'examinerSingular', isOverride: false } as Aliases;

  @ViewChild('fullCalendar', { static: true })
  fullCalendar: ElementRef;

  @ViewChild('dialogEventPopup') dialogEvnetpopup: TemplateRef<any>;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    public alias: InpageAliasService,
    public claimConfigService: ConfigurationService,
    public claimDataService: ClaimDataService,
    private cdr: ChangeDetectorRef,
    private userAction: UserActionService,
    private session: Session,
    private encrypt: EncryptionService,
    private translationPipe: TranslationPipe,
    private translationService: TranslationService
  ) {
    //customizations for nat grid
    this.showTimeStamp = this.showReasonSubtype =
      !this.claimConfigService.getConfigFeatureAccess('IncidentalAbsence');
  }

  /**
   * Gets the locale string based on language preference
   * @returns Locale string for DatePipe (e.g., 'en-US', 'es-US', 'fr-FR')
   */
  getLocale(): string {
    const languagePreference = sessionStorage.getItem('languagepreference');
    if (!languagePreference || languagePreference === 'en') {
      return 'en-US';
    }

    // Map common language codes to locale strings
    const localeMap: { [key: string]: string } = {
      'es': 'es-US', // Spanish (US)
      'fr': 'fr-FR', // French
      'de': 'de-DE', // German
      'zh': 'zh-CN', // Chinese
      'ja': 'ja-JP', // Japanese
      'pt': 'pt-BR', // Portuguese (Brazil)
      'it': 'it-IT', // Italian
      'ko': 'ko-KR', // Korean
      'ar': 'ar-SA', // Arabic
      'ru': 'ru-RU', // Russian
      'nl': 'nl-NL', // Dutch
      'pl': 'pl-PL', // Polish
      'sv': 'sv-SE', // Swedish
      'tr': 'tr-TR', // Turkish
    };
    return localeMap[languagePreference.toLowerCase()] || 'en-US';
  }

  async ngOnInit() {
    this.events = [...this.events];
    this.isIncidentalAbsence4Feature =
      await this.claimConfigService.getConfigFeatureAccess('IncidentalAbsence');
    this.showTimeStamp = this.showReasonSubtype =
      !this.isIncidentalAbsence4Feature;
    if (this.claimConfigService.GetConfig?.configFeatures?.aliases) {
      this.examinerAlias = await this.alias.replaceAliases(
        'examinerSingular',
        this.claimConfigService.GetConfig.configFeatures.aliases
      );
    }
    this.render();
  }

  ngOnChanges() {
    // console.log('it changed', this.events);
    this.render();
    this.updateButtonTextAfterRender();
  }

  ngAfterViewInit() {
    this.wcagCompliance();
    this.updateButtonTextAfterRender();
    this.removeDotsFromWeekNames();
  }

  update() {
    if (this.fullCalendar?.nativeElement) {
      this.fullCalendar.nativeElement._calendar.updateSize();
      this.fullCalendar.nativeElement._calendar.render();
      this.wcagCompliance();
      this.removeDotsFromWeekNames();
    }
  }

  getLeaveStatus(data: CalendarEvent) {
    const leaveStatus: string = data.data.entry.status;
    return leaveStatus;
  }

  getLeaveStatusReduceWS(data: CalendarEvent) {
    let leaveStatus: string = data.data.entry.status + ' - ';
    if (
      data.data.entry.absenceReason != undefined &&
      data.data.entry.absenceReason != null &&
      data.data.entry.absenceReason.trim().length > 2
    ) {
      leaveStatus = leaveStatus + data.data.entry.absenceReason;
    } else {
      leaveStatus = leaveStatus + ' None';
    }

    return leaveStatus;
  }

  get isEventDetails(): boolean {
    return this.eventData?.data?.entry?.isEvent === true;
  }

  get eventTypeDisplay(): string {
    const absenceStatus: string = this.eventData?.data?.entry?.absenceStatus ?? '';
    if (absenceStatus.toLowerCase() === 'nonimpactingevent') {
      return 'Non-Impacting Event';
    }
    if (absenceStatus.toLowerCase() === 'impactingevent') {
      return 'Impacting Event';
    }
    return absenceStatus;
  }

  getAbsenceStatusDisplay(data: CalendarEvent): string {
    const entry = data?.data?.entry;
    if (!entry) {
      return '';
    }

    const translatedStatus = entry.absenceStatus
      ? this.translationPipe.transform(entry.absenceStatus, this.translationRequest)
      : '';

    const isTams = data?.data?.claimDetails?.source !== 'L';
    const hasSubStatus =
      isTams &&
      !!entry.absenceSubStatus;

    if (!hasSubStatus) {
      return translatedStatus;
    }

    const translatedSubStatus = this.translationPipe.transform(
      entry.absenceSubStatus,
      this.translationRequest
    );

    return `${translatedStatus} - ${translatedSubStatus}`;
  }

  mockData() {
    const colors = this.dark ? this.darkColors : this.lightColors;
    const textColor = this.dark ? 'white' : 'black';
    const events: EventInput[] = [];
    for (let i = 0; i < 5 && this.mockData; i++) {
      const x1 = Math.floor(Math.random() * 28);
      const x2 = Math.floor(Math.random() * 28);
      const y = new Date().getFullYear();
      const m = new Date().getMonth();
      const start = new Date(y, m, Math.min(x1, x2));
      const end = new Date(y, m, Math.max(x1, x2));
      const color = this.nextColor(colors);
      events.push({
        title: `event ${i + 1}`,
        start,
        end,
        backgroundColor: color,
        borderColor: color,
        textColor: textColor,
        allDay: true,
      });
    }
  }

  render() {
    const colors = this.dark ? this.darkColors : this.lightColors;
    this.shuffle(colors);

    const eventInputs: EventInput[] = this.events?.map((ce) => {
      const ei = <EventInput>ce;
      if (!ei.backgroundColor) {
        ei.backgroundColor = this.nextColor(colors);
        ei.borderColor = ei.backgroundColor;
        ei.textColor = this.dark ? 'white' : 'black';
      }

      return ei;
    });
    const pluginslst: PluginDef[] = [resourceDayGridPlugin];

    if (this.IsListViewShow) {
      pluginslst.push(listPlugin);
    }


    this.calendarOptions = {
      plugins: pluginslst,
      aspectRatio: 1,
      //headingLevel: 4, need to upgrade to beta 7 version to use this property
      events: eventInputs,
      locale: this.getLocale(),
      navLinks: false,
      editable: true,
      headerToolbar: {
        left: this.toolbarLeft,
        center: 'title',
        right: this.toolbarRight,
      },
      height: 'auto',
      contentHeight: 'auto',
      schedulerLicenseKey: this.session.user.schedulerKey,
      datesSet: (dateinfo: any) => this.dateSetCallback(dateinfo),
      buttonText: this.getButtonText(),
      eventClick: (args: EventClickArg) => {
        if (this.IsAbsence) {
          this.popupTitle =
            args.event.extendedProps['firstName'] +
            ' ' +
            args.event.extendedProps['lastName'] +
            ' - ' +
            args.event.extendedProps['absenceReason'];
          this.dialog.open(this.dialogEvnetpopup);
          this.absenceDetail = new IncidentalAbsence();
          this.absenceDetail.absenceReason =
            args.event.extendedProps['absenceReason'];
          this.absenceDetail.absenceNumber =
            args.event.extendedProps['absenceNumber'];
          this.absenceDetail.absenceStartDate =
            args.event.extendedProps['absenceStartDate'];
          this.absenceDetail.absenceEndDate =
            args.event.extendedProps['absenceEndDate'];
          this.absenceDetail.estimatedRTWDate =
            args.event.extendedProps['estimatedRTWDate'];
          this.absenceDetail.typeOfCallOff =
            args.event.extendedProps['typeOfCallOff'];
        } else {
          this.popupTitle = 'Event';
          this.dialog.open(this.dialogEvnetpopup);
          this.eventData = args.event.extendedProps;
        }
      },
      //WCAG compliance custom code
      eventContent: (arg) => {
        return {
          html: `
          <span class="fc-event-title">${arg.event.title}</span>
          <span class='sr-only'>From ${arg.event.start?.toDateString()} to ${arg.event.end?.toDateString()} </span>
          `,
        };
      },
      dayCellDidMount: (arg) => {
        const anchor = arg.el.querySelector('a');
        if (anchor) {
          anchor.setAttribute('role', 'presentation');
          const span = document.createElement('span');
          span.innerHTML = anchor.innerHTML;
          span.setAttribute('aria-label', arg.date.toDateString());
          span.classList.add('sr-only');
          anchor.appendChild(span);
          anchor.removeAttribute('aria-pressed');
        }
      },
    };
  }

  private shuffle(array: string[]) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  private updateButtonTextAfterRender(): void {
    if (this.fullCalendar?.nativeElement?._calendar) {
      setTimeout(() => {
        const calendar = this.fullCalendar.nativeElement._calendar;
        if (calendar) {
          // Update button text
          const buttonText = this.getButtonText();
          if (calendar.setOption) {
            calendar.setOption('buttonText', buttonText);
          }
          // Force a re-render to apply changes
          calendar.render();
          this.removeDotsFromWeekNames();
        }
      }, 300); // Small delay to ensure translations are loaded
    }
  }

  private getButtonText(): { today: string; month: string; week: string; day: string; list: string } {
    const getTranslation = (key: string): string => {
      // First try synchronous translation service
      if (this.translationRequest && this.translationService.isLanguagePreferenceSet()) {
        const translated = this.translationService.getTranslationForKey(key.toLowerCase(), this.translationRequest);
        if (translated && translated !== key.toLowerCase()) {
          return translated;
        }
      }
      // Fallback to pipe transform
      if (this.translationRequest) {
        return this.translationPipe.transform(key, this.translationRequest);
      }
      return key;
    };

    return {
      today: getTranslation('Today'),
      month: getTranslation('Month'),
      week: getTranslation('Week'),
      day: getTranslation('Day'),
      list: getTranslation('List')
    };
  }

  private nextColor(colors: string[]): string {
    if (this.colorIndex === colors.length - 1) {
      this.colorIndex = 0;
    }

    return colors[this.colorIndex++];
  }

  closeModalPopUp() {
    this.dialog.closeAll();
  }
  async NavigateClaim() {
    const encryptedEmpUnum = this.encrypt.encrypt(
      this.eventData.data.entry.empUnum
    );
    this.router.navigate(['claims'], {
      queryParams: {
        claimId: this.eventData.data.entry.claimId,
        source: this.eventData.data.entry.source,
        lob: this.eventData.data.entry.lob,
        emp: !this.eventData.data.entry.userOwns ? encryptedEmpUnum : null,
      },
    });
    this.closeModalPopUp();
  }

  getStatusFromStatusCode(entry: StatusEvent) {
    if (entry.statusCode == 'OA') {
      return 'Open - Approved';
    } else if (entry.statusCode == 'OP') {
      return 'Open - Pending';
    } else if (entry.statusCode == 'DP') {
      return 'Denied - Pending';
    } else if (entry.statusCode == 'DA') {
      return 'Denied - Approved';
    } else if (entry.statusCode == 'OD') {
      return 'Denied';
    } else if (entry.statusCode == 'WP') {
      return 'Waiting Period';
    } else {
      return entry.status;
    }
  }

  getStatusOthers(entry: StatusEvent) {
    if (entry.lob.toLowerCase() != 'lv') {
      if (entry.statusCode) {
        return this.getStatusFromStatusCode(entry);
      } else {
        return entry.status;
      }
    } else if (
      entry.source === 'L' &&
      (entry.absenceStatus.toLowerCase() == 'pending' ||
        entry.absenceStatus.toLowerCase() == 'denied' ||
        entry.absenceStatus.toLowerCase() == 'waiting period')
    ) {
      return this.getStatusWithoutSubStatus(entry.status) + entry.absenceStatus;
    } else {
      if (entry.statusCode) {
        return this.getStatusFromStatusCode(entry);
      } else {
        return entry.status;
      }
    }
  }

  getStatusWithoutSubStatus(status: string) {
    if (status != undefined && status.length > 3 && status.indexOf('-') > -1) {
      return status.split('-')[0] + ' - ';
    } else {
      return '';
    }
  }

  getStatusOthersWithSubStatus(entry: StatusEvent) {
    if (entry.statusCode) {
      return this.getStatusFromStatusCode(entry);
    } else if (entry.subStatus) {
      return entry.status + '-' + entry.subStatus;
    } else {
      return entry.status;
    }
  }

  getWCClaimStatus(entry: StatusEvent) {
    if (entry.statusCode) {
      if (entry.statusCode == 'OA') {
        return 'Open - Approved';
      } else if (entry.statusCode == 'OP') {
        return 'Open - Pending';
      } else if (entry.statusCode == 'WP' || entry.statusCode == 'WA') {
        return 'Waiting';
      } else if (
        entry.statusCode == 'DP' ||
        entry.statusCode == 'DA' ||
        entry.statusCode == 'OD'
      ) {
        return 'Denied';
      }
    }

    if (entry.subStatus != undefined && entry.subStatus.length > 2) {
      return entry.status + ' - ' + entry.subStatus;
    } else {
      return entry.status;
    }
  }

  removedots(examinerName: string) {
    if (examinerName != undefined) {
      const dotIndex = examinerName.lastIndexOf('.');
      if (dotIndex == examinerName.length - 1) {
        return examinerName.substring(0, dotIndex);
      }
    }
    return examinerName;
  }

  private removeDotsFromWeekNames(): void {
    // Clear any existing timeout to prevent multiple queued timeouts
    if (this.removeDotsTimeout) {
      clearTimeout(this.removeDotsTimeout);
    }

    if(this.translationRequest == undefined || this.translationRequest.language == undefined || this.translationRequest.language.toLowerCase() == 'en')
    {
      return;
    }

    this.removeDotsTimeout = setTimeout(() => {

      // Find all week name elements in FullCalendar day headers
      const weekNameElements = document.getElementsByClassName('fc-col-header-cell-cushion');

      // Convert HTMLCollection to Array to use forEach
      Array.from(weekNameElements).forEach((element: Element) => {
        const htmlElement = element as HTMLElement;

        if (htmlElement.textContent) {
          let textWithoutDots = htmlElement.textContent;
          // Only modify if dots are present to avoid duplicate modifications
          if (htmlElement.textContent.length > 3 && !htmlElement.textContent.includes('/')) {
            htmlElement.textContent.split('.').forEach((part: string, index: number) => {

              if (index === 0) {
                textWithoutDots = part.slice(0, 1).toUpperCase() + part.slice(1, 3).toLowerCase();
              }
            });
          }
          else {
            if (htmlElement.textContent.includes('/')) {
              textWithoutDots = htmlElement.textContent.slice(0, 1).toUpperCase() + htmlElement.textContent.slice(1).toLowerCase();
            }
            else {
              textWithoutDots = htmlElement.textContent.slice(0, 1).toUpperCase() +
                htmlElement.textContent.slice(1, 3).toLowerCase();
            }
          }

          htmlElement.innerHTML = '';
          htmlElement.innerHTML = textWithoutDots;
          element.innerHTML = textWithoutDots;

           setTimeout(() => {
            if (element.textContent.includes('.') && !element.textContent.includes('/')) {
              element.innerHTML = htmlElement.textContent.slice(0, 1).toUpperCase() +
                htmlElement.textContent.slice(1, 3).toLowerCase();
            }
            else if (element.textContent.includes('/')) {
              element.innerHTML = htmlElement.textContent.replace('.', '');
            }
            else if(element.textContent.length > 3 && !element.textContent.includes('/')){
              element.innerHTML = htmlElement.textContent.slice(0, 1).toUpperCase() +
              htmlElement.textContent.slice(1, 3).toLowerCase();
            }

            setTimeout(() => {
            
            if (element.textContent.includes('.') && !element.textContent.includes('/')) {
              element.innerHTML = htmlElement.textContent.slice(0, 1).toUpperCase() +
                htmlElement.textContent.slice(1, 3).toLowerCase();
            }
            else if (element.textContent.includes('/')) {
              element.innerHTML = htmlElement.textContent.replace('.', '');

              if(element.innerHTML.length > 9){
                element.innerHTML = htmlElement.textContent.slice(0, 3);
              }
            }
            else if(element.textContent.length > 3 && !element.textContent.includes('/')){
              element.innerHTML = htmlElement.textContent.slice(0, 1).toUpperCase() +
              htmlElement.textContent.slice(1, 3).toLowerCase();
            }
          },2500);
          }, 100);
        }
      });
    }, 50); // Small delay to ensure calendar is rendered
  }

  wcagCompliance() {
    const buttons = document.querySelectorAll('button[aria-pressed]');
    if (buttons.length > 0) {
      buttons.forEach((button) => {
        button.removeAttribute('aria-pressed');
        button.setAttribute('aria-label', button.getAttribute('title') || '');
        button.removeAttribute('title');
      });
    }
  }
}